export default "__VITE_ASSET__Da5vyNVk__ 400w, __VITE_ASSET__DpdnjeZK__ 800w, __VITE_ASSET__BY13uEad__ 1200w";